@switch (column.GridColumnType) {
    @case (GridColumnType.Text) {
        <input class="h-10"
               [class.ng-invalid]="value == null && column.required"
               [ngModel]="value"
               (ngModelChange)="onValueChange($event)"
               type="text">
    }
    @case (GridColumnType.Numeric) {
        <input class="h-10"
               [class.ng-invalid]="value == null && column.required || !control.valid"
               [ngModel]="value"
               (ngModelChange)="onValueChange($event)"
               type="number">
    }
    @case (GridColumnType.Checkbox) {
        <input class="h-10"
               [class.ng-invalid]="value == null && column.required"
               [ngModel]="value"
               (ngModelChange)="onValueChange($event)"
               type="checkbox">
    }
    @case (GridColumnType.Enum) {
        <kendo-combobox
                [data]="column.Enum"
                textField="Text"
                valueField="Value"
                [valuePrimitive]="true"
                [formControl]="control"
        >
            <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span>{{ dataItem.Text | translate }}</span>
            </ng-template>
        </kendo-combobox>
    }
    @case (GridColumnType.ColorEnum) {
        <kendo-multiselect [data]="CHECKLIST_BUTTON_DEFAULT_COLORS"
                           class="bizz-combobox-multiselect hidden-input"
                           textField="Text"
                           valueField="Value"
                           [clearButton]="false"
                           [value]="selectedColor"
                           (valueChange)="selectedColorPresetChanged($event)"
                           [listHeight]="500">
            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                <div class="cursor-pointer rounded-full py-1"
                     [style]="{'background-color' : rowData.BackgroundColor + (isDarkTheme() ? 'FF' : '33') }">
                    <!--33 (hex) = 20% opacity-->
                    <span [style]="{'color' : isDarkTheme() ? 'white' : rowData.ForegroundColor }"
                          class="font-bold">{{ dataItem.Text | translate }}</span>
                </div>
            </ng-template>
            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                <div class="rounded-full px-4 py-1"
                     [style]="{'background-color' : dataItem.Value?.BackgroundColor + (isDarkTheme() ? 'FF' : '33')  }">
                    <span [style]="{'color' : isDarkTheme() ? 'white' : dataItem.Value?.ForegroundColor }"
                          class="font-bold">{{ dataItem.Text | translate }}</span>
                </div>
            </ng-template>
        </kendo-multiselect>
    }
    @case (GridColumnType.CustomColorEnum) {
        <kendo-colorpicker
                class="[&>*]:hidden [&>span]:rounded-full bg-transparent border-none rounded-full [&>.k-input-inner]:!p-0"
                #toolbar
                [views]="['palette','gradient']"
                [clearButton]="true"
                [format]="'hex'"
                [paletteSettings]="BizzColorPaletteSettings"
                [gradientSettings]="{ opacity: false }"
                [value]="value"
                (valueChange)="onCustomColorChanged($event)"
        ></kendo-colorpicker>
    }
}
